// 定义德语语言包对象
export default {
  Language: 'Deutsch',
  // 导航栏
  nav_cashier: 'Kasse',
  
  // 支付收银台
  payment_title: 'Zahlungskasse',
  payment_amount_label: 'Bitte geben Sie den Betrag ein',
  payment_method_title: 'Zahlungsmethode auswählen',
  payment_method_wechat: 'WeChat Pay',
  payment_method_alipay: 'Alipay',
  payment_method_unionpay: 'UnionPay',
  payment_button: 'Jetzt bezahlen HK${amount}',
  payment_loading: 'Verarbeitung...',
  
  // 支付调起页面
  payment_password_title: 'Bitte geben Sie das Zahlungskennwort ein',
  payment_password_placeholder: 'Bitte geben Sie das 6-stellige Zahlungskennwort ein',
  payment_password_hint: 'Bitte geben Sie das Zahlungskennwort in {paymentMethod} ein',
  payment_cancel: 'Abbrechen',
  payment_confirm: 'Zahlung bestätigen',
  
  // 支付成功提示
  payment_success: 'Zahlung erfolgreich',
  payment_amount: 'Zahlungsbetrag:',
  payment_method: 'Zahlungsmethode:',
  payment_transaction_id: 'Transaktions-ID:',
  payment_time: 'Zahlungszeit:',
  payment_ok: 'OK',
  
  // 弹窗提示
  payment_amount_error: 'Bitte geben Sie einen gültigen Zahlungsbetrag ein',
  payment_password_error: 'Bitte geben Sie das 6-stellige Zahlungskennwort ein',
  
  // 银联支付
  unionpay_scan_title: 'UnionPay QR-Code-Zahlung',
  unionpay_scan_hint: 'Bitte laden Sie den QR-Code herunter und scannen Sie ihn mit der Cloud QuickPass APP',
  unionpay_download_button: 'QR-Code herunterladen',
  unionpay_download_success: 'QR-Code im Album gespeichert',
  unionpay_download_failed: 'Download fehlgeschlagen, bitte versuchen Sie es erneut',
  unionpay_mobile_save_hint: 'Lange auf das Bild drücken und "Bild speichern" auswählen',
  unionpay_desktop_save_hint: 'Bitte klicken Sie mit der rechten Maustaste und speichern Sie das Bild in einem neuen Fenster',
  unionpay_mobile_long_press: 'Lange drücken zum Speichern'
};